export default {
  title: 'NOL',
  additionalMetaTags: [
    {
      name: 'google',
      content: 'notranslate',
    },
    {
      name: 'keywords',
      content: '놀, nol, 야놀자, yanolja',
    },
  ],
  openGraph: {
    title: 'NOL',
    images: [{ url: 'https://yaimg.yanolja.com/joy/sunny/static/images/nol/nol_og_1200x600.png' }],
  },
}
